// Local imports
import React from 'react';
import { Box, CssBaseline } from '@mui/material';
import { Outlet } from 'react-router-dom';


// Component definition
export default function LoginLayout() {
  return (
    <Box sx={{ display: 'flex'}}>
      <CssBaseline />
      <Box component="main" sx={{ flexGrow: 1, p: 3, height: '100%'}}>
        <Outlet />
      </Box>
    </Box>
  );
}
